import React from 'react';
const AuthError = () => {
	

	return (
		<div className="app-page">
			<div className="title-page"> 
                <h2>You are not authorized.</h2>
			</div>
		</div>
	);
};

export default AuthError;